module.exports = __webpack_public_path__ + "static/img/s6.03064f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s6.png
// module id = clG8
// module chunks = 0